// Luminous common
// --------------------------------------------
(function () {
  document
    .querySelectorAll(
      '.js-zoom a[href$=".jpg"], .js-zoom a[href$=".png"]'
    )
    .forEach((luminousTrigger) => {
      luminousTrigger.classList.add("has-zoom-icon");
      luminousTrigger.insertAdjacentHTML(
        "beforeend",
        '<span class="btn is-type-square-03 is-parent-link"><i class=" icon-font-zoom"></i></span>'
      );
      const overflowClass = "is-clipped";
      const options = {
        onOpen: function () {
          return document.querySelector("html").classList.add(overflowClass);
        },
        onClose: function () {
          return document.querySelector("html").classList.remove(overflowClass);
        },
      };
      new Luminous(luminousTrigger, options);
    });
})();
